import HomeCompany from '../../components/home-company/HomeCompany';
import HomeFocus from '../../components/home-focus/HomeFocus';
import HomeHero from '../../components/home-hero/HomeHero';
import HomeTestimonial from '../../components/home-testimonial/HomeTestimonial';
import HomeWhy from '../../components/home-why/HomeWhy';
import './home.scss';

const Home = () => {
  return (
    <main className="home-page">
      <div className="home-page__top">
        <HomeHero />
        <HomeFocus />
      </div>
   
      <HomeWhy />
      <HomeTestimonial />
      <HomeCompany />
    </main>
  );
};

export default Home;
